/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import update from 'immutability-helper';

import * as types from '../constants/ActionTypes';

export const getInitialState = () => ({
  data: null,
  isLoading: false,
  error: null,
  open: false,
});

const initialState = getInitialState();

const BOSDialog = (state = initialState, { type, error, data, bucket, bucketName }) => {
  switch (type) {
    case types.LOAD_BOS_BUCKETS_REQUEST:
      return { ...state, isLoading: true };
    case types.LOAD_BOS_BUCKETS_FAILURE:
      return { ...state, error, isLoading: false };
    case types.LOAD_BOS_BUCKETS_SUCCESS:
      return { ...state, data, isLoading: false };

    case types.OPEN_BOS_MAIN_DIALOG:
      return { ...state, open: true };
    case types.CLOSE_BOS_MAIN_DIALOG:
      return { ...state, open: false };
    case types.DELETE_BOS_BUCKET_FAILURE:
      return { ...state, error, isLoading: false };
    case types.DELETE_BOS_BUCKET_SUCCESS:
      return { ...state, isLoading: false };
    case types.DELETE_BOS_BUCKET_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.ADD_BOS_BUCKET_ROW: {
      const b1 = bucket;
      const b2 = {
        Name: b1.name,
        LocationConstraint: `${b1.location}-${b1.storageClass}`,
      };
      return Array.isArray(state.data)
        ? update(state, {
            data: {
              $push: [b2],
            },
          })
        : { ...state, data: [b2] };
    }
    case types.REMOVE_BOS_BUCKET_ROW: {
      const index = state.data.findIndex(item => item.Name === bucketName);
      return index !== -1
        ? update(state, {
            data: {
              $splice: [[index, 1]],
            },
          })
        : state;
    }
    case types.CREATE_BOS_BUCKET_FAILURE:
      return { ...state, error, isLoading: false };
    case types.CREATE_BOS_BUCKET_SUCCESS:
      return { ...state, isLoading: false };
    case types.CREATE_BOS_BUCKET_REQUEST:
      return { ...state, isLoading: true, error: null };
    default:
      return state;
  }
};

export default BOSDialog;
